import { Alert } from "@svea/design-system-components-react";
import { Heading, Stack, SvgIcon, Text, useLogin, useText } from "@sveabank/cc-common";
import Paper from "../../components/paper";
import { APPCONFIG } from "../../utils/config";
import ConsentModal from "./consent-modal";
import LoginForm from "./login-form";
import LoginInProgress from "./login-in-progress";

const LoginPage = () => {
	const { loginState, isSameDevice } = useLogin();
	const [t, texts] = useText();

	const alertMsg = APPCONFIG.ALERT_MESSAGE;

	const title = isSameDevice
		? texts.loginPage.loginInProgress.titleSameDevice
		: texts.loginPage.loginInProgress.titleOtherDevice;

	return (
		<>
			<div className="mx-auto max-w-md">
				<Stack gap={4}>
					{alertMsg.length > 1 && <Alert kind="error">{alertMsg}</Alert>}
					<Paper className="bg-background-primary" padding="2xl">
						<Stack gap={8} align="center" justify="center">
							<SvgIcon imageSrc="BANKID_CIRCLE" height={80} />
							<Text align="center">
								<Heading.H1 italic={false} size="h2">
									{t(title)}
								</Heading.H1>
							</Text>
							{loginState === "PENDING" ? <LoginInProgress /> : <LoginForm />}
						</Stack>
					</Paper>
				</Stack>
			</div>

			<ConsentModal />
		</>
	);
};

export default LoginPage;
